module.exports = __webpack_public_path__ + "img/mspjDaFen.5972f4c1.png";